import { Context, useContext } from 'react'
import {
  StateMachineContext,
  type StateMachineContextProps,
} from './StateMachineContext'

export const useStateMachine = <T = unknown>() =>
  useContext<StateMachineContextProps<T>>(
    StateMachineContext as Context<StateMachineContextProps<T>>,
  )
